module.exports = __webpack_public_path__ + "static/media/analytics.709640bf.png";